export function replaceProgrammeMeal(selectedProgramme, programmeMealEditTarget, recipe) {
  if (!recipe || !selectedProgramme || !programmeMealEditTarget) {
    return selectedProgramme;
  }

  const updatedWeeks = [...(selectedProgramme.weeks || [])];
  const targetWeek = updatedWeeks[programmeMealEditTarget.weekIndex];

  if (!targetWeek) {
    return selectedProgramme;
  }

  updatedWeeks[programmeMealEditTarget.weekIndex] = {
    ...targetWeek,
    days: {
      ...targetWeek.days,
      [programmeMealEditTarget.day]: {
        ...targetWeek.days[programmeMealEditTarget.day],
        [programmeMealEditTarget.mealType]: recipe.name
      }
    }
  };

  return {
    ...selectedProgramme,
    weeks: updatedWeeks
  };
}